class AutocompleteStateLayer {
  constructor () {
    this.state = {
      activeFacets: [],
      activeSort: null,
      facets: [],
      lastSelectedDetail: null,
      makers: [],
      pagination: {
        currentPage: 1,
        offset: window.theme.collection.limit,
      },
      products: [],
      suggestions: [],
      totalProducts: null,
    }

    this.subscribeToEvents()
  }

  /**
   * Updates a URL parameter and pushes the new state to history
   * @param {string} paramName - The name of the parameter to update
   * @param {string|null} paramValue - The value to set, or null to remove the parameter
   */
  updateUrlParameter (paramName, paramValue) {
    const url = new URL(window.location.href)
    if (paramValue) {
      url.searchParams.set(paramName, paramValue)
    } else {
      url.searchParams.delete(paramName)
    }
    window.history.pushState({ path: url.toString() }, '', url.toString())
  }

  subscribeToEvents () {
    const eventBus = window.theme.autocompleteResults.eventBus

    eventBus.subscribe('api:products:fetched', response => {
      this.products = response.queryResults[0].records
      this.totalProducts = response.queryResults[0].meta.totalResultsFound
      this.facets = response.queryResults[0].filters
      this.suggestions = response.suggestionResults[0].suggestions
    })

    eventBus.subscribe('api:makers:fetched', records => {
      this.makers = records
    })

    eventBus.subscribe('api:facets:fetched', response => {
      this.facets = response
    })

    eventBus.subscribe('pagination:control:load-more', () => {
      this.offset += window.theme.collection.limit
      this.currentPage += 1

      // Update URL with current page parameter
      this.updateUrlParameter('auto_page', this.currentPage)
    })

    eventBus.subscribe('pagination:control:load-previous', () => {
      if (this.currentPage === 2) {
        this.offset = 0
      } else {
        this.offset -= window.theme.collection.limit
      }
      this.currentPage -= 1

      this.updateUrlParameter('auto_page', this.currentPage)
    })

    eventBus.subscribe('state:sort:updated', value => {
      this.activeSort = value
      this.updateUrlParameter('sort_by', this.activeSort)
    })
  }

  get makers () {
    return this.state.makers
  }

  set makers (makers) {
    this.state.makers = makers
    window.theme.autocompleteResults.eventBus.publish(
      'state:makers:updated',
      makers,
    )
  }

  get suggestions () {
    return this.state.suggestions
  }

  get products () {
    return this.state.products
  }

  get totalProducts () {
    return this.state.totalProducts
  }

  get offset () {
    return this.state.pagination.offset
  }

  get currentPage () {
    return this.state.pagination.currentPage
  }

  get activeSort () {
    return this.state.activeSort
  }

  get facets () {
    return this.state.facets
  }

  set facets (facets) {
    this.state.facets = facets
    window.theme.autocompleteResults.eventBus.publish(
      'state:facets:updated',
      facets,
    )
  }

  set suggestions (suggestions) {
    this.state.suggestions = suggestions
    window.theme.autocompleteResults.eventBus.publish(
      'state:suggestions:updated',
      suggestions,
    )
  }

  set products (products) {
    this.state.products = products
    window.theme.autocompleteResults.eventBus.publish(
      'state:products:updated',
      products,
    )
  }

  set totalProducts (totalProducts) {
    this.state.totalProducts = totalProducts
    window.theme.autocompleteResults.eventBus.publish(
      'state:totalProducts:updated',
      totalProducts,
    )
  }

  set offset (offset) {
    this.state.pagination.offset = offset
    window.theme.autocompleteResults.eventBus.publish(
      'state:offset:updated',
      offset,
    )
  }

  set currentPage (currentPage) {
    this.state.pagination.currentPage = currentPage
    window.theme.autocompleteResults.eventBus.publish(
      'state:currentPage:updated',
      currentPage,
    )
  }

  set activeSort (activeSort) {
    this.state.activeSort = activeSort
    window.theme.autocompleteResults.eventBus.publish(
      'state:activeSort:updated',
      activeSort,
    )
  }

  set activeFacets (facets) {
    this.state.activeFacets = facets

    if (this.currentPage > 1) {
      this.offset = 0
      this.currentPage = 1
      this.updateUrlParameter('auto_page', null)
    }

    window.theme.autocompleteResults.eventBus.publish(
      'state:activeFacets:updated',
      facets,
    )
  }

  get activeFacets () {
    return this.state.activeFacets
  }
}

window.theme.autocompleteResults.stateLayer = new AutocompleteStateLayer()
